// extracted by css-extract-rspack-plugin
export default {"cls1":"BibliographyList-cls1_vh6","cls2":"BibliographyList-cls2_Oi- BibliographyList-cls1_vh6"};